<template>
    <div>
<!--    <div class="nav">小雨点</div>-->

    <!-- 搜索框 -->
    <div class='t_search'>
        <div class="box-shadow clearbox">
            <input class="searchinput" v-model="search" placeholder="搜索请输入" />
            <button @click='searchData'>
                <img src="/img/sou.png" alt="">
            </button>
        </div>

        <!-- 年级tab -->
        <div class="njtab clearfix">
            <div @click="changeTab(index,'currentTab')" :class="'njtab-div '+(index==currentTab?'active':'')" :key="item.value" v-for="(item,index) of course_level">
                {{item.label}}
            </div>
        </div>
        <!-- 年级tab -->
    </div>
    <!-- 搜索框= -->

    <!-- 类型tab -->
    <div class="lbtab clearfix">
        <div @click="changeTab(index,'currentType')" :class="'lbtab-div '+(index==currentType?'on':'')" :key="item.value" v-for="(item,index) of course_type">{{item.label}}</div>
    </div>
    <!-- 类型tab -->

    <div class="show">
        <div class="xsbox">
            <div class="xsbox-li" v-for="(item) of course_data.list" :key="item.id" @click="toUrl(item.courseId,item.courseType,item.courseLevel)">
                <img :src="imgprefix+item.picUrl" alt="">
                <div class="xsbox-li-r">
                    <div class="xsbox-li-title">{{item.title}}</div>
                    <div class="xsbox-li-sm">{{item.description}}</div>
                    <div class="xsbox-li-tb">
                        <div>
                            <img src="/img/bf.png" alt="">
                            <span>{{item.playNum}}</span>
                        </div>
                        <div>
                            <img src="/img/bj.png" alt="">
                            <span>{{item.taskNum}}</span>
                        </div>
                        <div>
                            <img src="/img/time.png" alt="">
                            <span>{{item.length}}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div v-if="course_data.list.length==0">
        <!--暂无数据-->
        <div class="no_data">
            <img src="img/zw.png" alt="">
            <label>暂无数据</label>
        </div>
        <!--暂无数据 end-->
    </div>
    </div>
</template>

<script>
    import { Indicator,Toast } from 'mint-ui';
    import wx from "weixin-js-sdk";
    import Utils from '../../js/common/utils';
    export default {
        data() {
            return {
                imgprefix: C.imgprefix,
                currentTab: 0, //级别索引
                currentType: 0, //类型索引
                course_level: [

                ], //级别
                course_type: [

                ], //类型
                course_data: {
                    list: [],
                    page: 1,
                    hasMoreData: true,
                },
                search: '', //搜索关键词
                userId:''
            };
        },
        created() {
            let userId=this.$route.query.userId;
            let currentUserToken=this.$route.query.currentUserToken;
            if(!userId){
                // Toast("参数错误");
                // return;
            }
            Utils.saveLocal('userId',userId || '');
            Utils.saveLocal('currentUserToken',currentUserToken || '');
            this.userId=userId || '';
            this.initShare()
            this.init()
        },
        mounted() {
            window.onscroll = ()=>{
                //变量scrollTop是滚动条滚动时，距离顶部的距离
                var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
                //变量windowHeight是可视区的高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                //变量scrollHeight是滚动条的总高度
                var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
                //滚动条到底部的条件
                if(scrollTop+windowHeight==scrollHeight){
                    //写后台加载数据的函数
                    this.getList()
                }
            }
        },
        methods: {
            init() {
                this.getDict()
            },
            //初始化分享参数
            initShare: function(){
                R.Wechat.queryWechatInfo({url: location.href}).then(res=>{
                    wx.config({
                        //debug:true,
                        appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: res.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.nonceStr, // 必填，生成签名的随机串
                        signature: res.signature,// 必填，签名，见附录1
                        jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });

                    wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
                        wx.updateAppMessageShareData({//分享给微信好友 qq好友
                            title: '春雨树线上课程', // 分享标题
                            desc: '绘画教会孩子去爱！创意不停歇，精彩永在线！', // 分享描述
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: location.origin+'/logo.jpg', // 分享图标
                            success: () => {
                                // 设置成功
                            }
                        })

                        wx.updateTimelineShareData({//分享到朋友圈 qq空间
                            title: '春雨树线上课程', // 分享标题
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: location.origin+'/logo.jpg', // 分享图标
                            success: () => {
                                // 设置成功
                            }
                        })
                    });
                })
            },
            toUrl: function(id, courseType, courseLevel){
                window.location.href = `/course?courseId=${id}&courseType=${courseType}&courseLevel=${courseLevel}`
            },
            getDict(){
                R.Dict.getType({type:'course_type,course_level'}).then(result=>{
                    let {
                            course_level,
                            course_type
                        } = result,
                        item = {
                            value: '',
                            label: '全部'
                        }
                    course_level.unshift(item)
                    course_type.unshift(item)
                    this.course_level = course_level
                    this.course_type = course_type
                    this.getList()
                }).catch(res=>{
                    console.log(res)
                })
            },

            //切换tab
            changeTab(index,type){
                this[type] = index
                this.clearSearch()
            },

            //搜索
            searchData() {
                this.currentType = 0
                this.currentTab = 0
                this.clearSearch()
            },

            //清空数组过滤，条件不动
            clearSearch() {
                this.course_data = {
                    list: [],
                    page: 1,
                    hasMoreData: true
                }
                this.requestLoading = false
                this.getList()
            },

            //查询列表数据
            getList: function() {
                if(this.requestLoading){
                    return
                }
                this.requestLoading = true

                let {
                    course_data,
                    course_level,
                    course_type,
                    currentTab,
                    currentType,
                    search
                } = this
                if(!course_data.hasMoreData){
                    Toast('无更多数据')
                    return
                }
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
                R.Course.getList({
                    search,
                    courseLevel: course_level[currentTab].value,
                    courseType: course_type[currentType].value,
                    page: course_data.page,
                    limit: 10
                }).then(result=>{
                    Indicator.close();
                    this.requestLoading = false
                    result.data.rows.forEach((item)=>{
                        this.course_data.list.push(item)
                    })
                    this.course_data.page++
                    if(this.course_data.list.length>=result.data.total){
                        this.course_data.hasMoreData = false
                    }
                })
            },
        },
        computed: {

        }
    };
</script>

<style scoped>

    .t_search {
        width: 100%;
        font-size: 14px;
        position: fixed;
        left: 0;
        /*top: 39px;*/
        z-index: 999;
        background-color: #ebecea;
    }

    .box-shadow {
        display: flex;
        align-items: center;
        padding: 0 15px;
        height: 46px;
        width: calc(100%);
        background: #fff;
        box-shadow: 0px 0px 8px 0px rgba(33, 33, 33, 0.3);
        color: #9a9a9a;
    }

    .t_search input {
        float: left;
        background: #fff;
        font-size: 14px;
        padding: 0 5px;
        color: #353535;
        width: calc(100% - 56px);
        height: 20px;
        line-height: 20px;
        vertical-align: top;
        border-right: 1px solid #b2b2b2;
    }

    .t_search button {
        width: 20px;
        height: 20px;
        display: inline-block;
        float: left;
        margin: 0 7px 0 18px;
        background: none;
        border: none;
        padding: 0;
    }

    .t_search button img {
        width: 20px;
        height: 20px;
        display: block;
        margin: 0 auto;
    }


    .searchinput {
        max-height: 26px;
        height: 26px;
        min-height: 26px;
    }

    .clearbox:after {
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }

    .clearbox {
        zoom: 1;
    }

    .clear,
    .clearfix {
        clear: both;
    }

    button::after {
        border: none;
    }

    .njtab {
        margin-top: 6px;
        height: 42px;
        line-height: 42px;
        font-size: 15px;
        color: #000;
        padding: 0 10px;
        background-color: #fff;
        border-bottom: 1px solid #edeeec;
        overflow: auto;
        white-space: nowrap;
    }

    .njtab :first-child{
        margin-left: 0;
    }

    .njtab-div {
        width: calc((100% - 30px)/4);
        height: 100%;
        margin: 0 5px;
        text-align: center;
        display: inline-block;
    }

    .njtab-div:last-child {
        margin-right: 0;
    }

    .njtab-div.active {
        color: #32a658;
        height: 40px;
        border-bottom: 2px solid #32a658;
    }

    .lbtab {
        /*height: 200px;*/
        padding: 102px 10px 0;
        border-bottom: 1px solid #edeeec;
        overflow: auto;
        white-space: nowrap;
    }

    .lbtab :first-child{
        margin-left: 0;
    }

    .lbtab-div {
        width: auto;
        height: 32px;
        border-radius: 16px;
        border: solid 1px rgba(101, 97, 97, 0.35);
        font-size: 15px;
        color: #000;
        padding: 0 19px;
        line-height: 29px;
        margin: 12px 5px 12px 5px;
        display: inline-block;
    }

    .lbtab-div.on {
        background-color: #32a658;
        color: #fff;
    }

    .xsbox {
        padding: 0 15px;
    }

    .xsbox-li {
        height: 117px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #edeeec;
    }

    .xsbox-li img {
        width: 115px;
        height: 77px;
        border-radius: 3px;
    }

    .xsbox-li .xsbox-li-r {
        font-size: 12px;
        width: calc(100% - 130px);
    }

    .xsbox-li-title {
        width: 100%;
        font-size: 16px;
        color: #000;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .xsbox-li-sm {
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0 13px 0;
    }

    .xsbox-li-tb img {
        width: 12px;
        height: 12px;
        vertical-align: -2px;
        margin-right: 3px;
    }

    .xsbox-li-tb {
        font-size: 13px;
        color: #333;
    }

    .xsbox-li-tb div {
        width: calc(100%/3);
        text-align: left;
        float: left;
    }

    .xsbox-li-tb div span {
        display: inline;
    }

    .show {
        display: block;
    }

    .hidden {
        display: none;
    }

    .scroll-div_H {
        overflow: hidden;
        white-space: nowrap;
    }

    .nav {
        height: 48px;
        padding-top: 20px;
        width: 100%;
        position: fixed;
        top: 0;
        text-align: center;
        display: flex;
        flex-direction: row;
        z-index: 9999;
        background: #F8F8F8;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        padding: 0;
        font-weight: 600;
    }
</style>
